module.exports = __webpack_public_path__ + "img/snkrblog-title.cce8e3fa.svg";